import React from 'react';
import styled from 'styled-components';
import { Label, colors } from '@commonsku/styles';
import CurrencyToggle from '../product-search/shared/CurrencyToggle';
import PriceRangeFilter from '../product-search/shared/PriceRangeFilter';
import ClearFiltersButton from '../product-search/shared/ClearFiltersButton';
import { POD_DIVISION_NAME } from '../../pod';

interface PoDFilterSidebarProps {
  minPrice: string;
  maxPrice: string;
  onChangeMinPrice: (value: string) => void;
  onChangeMaxPrice: (value: string) => void;
  onClearFilters: () => void;
}

const SupplierBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

const SupplierName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.primary1['65']};
`;

const PoDFilterSidebar: React.FC<PoDFilterSidebarProps> = ({
  minPrice,
  maxPrice,
  onChangeMinPrice,
  onChangeMaxPrice,
  onClearFilters,
}) => {
  return (
    <>
      <SupplierBlock>
        <Label>Supplier</Label>
        <SupplierName>
          {POD_DIVISION_NAME}
        </SupplierName>
      </SupplierBlock>
      <CurrencyToggle
        options={[{ value: 'USD', isRefined: true, iconSrc: '/images/icons/us1.svg' }]}
        onToggle={() => { /* USD is the only PoD currency */ }}
      />
      <PriceRangeFilter
        minValue={minPrice}
        maxValue={maxPrice}
        onChangeMin={onChangeMinPrice}
        onChangeMax={onChangeMaxPrice}
      />
      <ClearFiltersButton
        canClear={'' !== minPrice || '' !== maxPrice}
        onClear={onClearFilters}
      />
    </>
  );
};

export default PoDFilterSidebar;
